/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressClient,
    AddressClientFromJSON,
    AddressClientFromJSONTyped,
    AddressClientToJSON,
    ReadOnlyUserTokenUser,
    ReadOnlyUserTokenUserFromJSON,
    ReadOnlyUserTokenUserFromJSONTyped,
    ReadOnlyUserTokenUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserToken
 */
export interface UserToken {
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    userId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof UserToken
     */
    readonly startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserToken
     */
    readonly endTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    tokenType: UserTokenTokenTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    holder?: string;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    userSurname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    userName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    userDeleted?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    userActive?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    userSsoId?: string | null;
    /**
     * 
     * @type {ReadOnlyUserTokenUser}
     * @memberof UserToken
     */
    user?: ReadOnlyUserTokenUser;
    /**
     * 
     * @type {AddressClient}
     * @memberof UserToken
     */
    client?: AddressClient;
}

export function UserTokenFromJSON(json: any): UserToken {
    return UserTokenFromJSONTyped(json, false);
}

export function UserTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'startTime': !exists(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !exists(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'token': json['token'],
        'tokenType': json['token_type'],
        'holder': !exists(json, 'holder') ? undefined : json['holder'],
        'userSurname': !exists(json, 'user_surname') ? undefined : json['user_surname'],
        'userName': !exists(json, 'user_name') ? undefined : json['user_name'],
        'userDeleted': !exists(json, 'user_deleted') ? undefined : json['user_deleted'],
        'userActive': !exists(json, 'user_active') ? undefined : json['user_active'],
        'userSsoId': !exists(json, 'user_sso_id') ? undefined : json['user_sso_id'],
        'user': !exists(json, 'user') ? undefined : ReadOnlyUserTokenUserFromJSON(json['user']),
        'client': !exists(json, 'client') ? undefined : AddressClientFromJSON(json['client']),
    };
}

export function UserTokenToJSON(value?: UserToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'token': value.token,
        'token_type': value.tokenType,
        'holder': value.holder,
        'user_surname': value.userSurname,
        'user_name': value.userName,
        'user_deleted': value.userDeleted,
        'user_active': value.userActive,
        'user_sso_id': value.userSsoId,
        'user': ReadOnlyUserTokenUserToJSON(value.user),
        'client': AddressClientToJSON(value.client),
    };
}

/**
* @export
* @enum {string}
*/
export enum UserTokenTokenTypeEnum {
    Ibutton = 'ibutton ',
    Rfid = 'rfid',
    DriverCard = 'driver_card',
    Pin = 'pin',
    App = 'app',
    DefaultDriver = 'default_driver'
}


